import * as localforage from 'localforage';

import { EncryptionKeyEnum } from '../../constants/encryption-key.ts';

import { EncryptionUtil } from '../encryption.util.ts';

export class ReduxStorageUtil {
  private static _instance: ReduxStorageUtil;

  static get instance(): ReduxStorageUtil {
    if (!ReduxStorageUtil._instance) {
      ReduxStorageUtil._instance = new ReduxStorageUtil();
    }

    return ReduxStorageUtil._instance;
  }

  constructor(
    private readonly encryptionUtil = new EncryptionUtil(
      EncryptionKeyEnum.REDUX_STORAGE,
      EncryptionKeyEnum.REDUX_STORAGE_SALT
    )
  ) {}

  async setItem(key: string, value: string): Promise<void> {
    const encryptedValue = await this.encryptionUtil.encrypt(value);
    await localforage.setItem(key, encryptedValue).catch(() => null);
  }

  async getItem(key: string): Promise<string | null> {
    const result = await localforage.getItem(key).catch(() => null);
    if (result) {
      return this.encryptionUtil.decrypt(result);
    }

    return null;
  }

  async removeItem(key: string): Promise<void> {
    await localforage.removeItem(key).catch(() => null);
  }
}

export const getReduxStorageUtil = (): ReduxStorageUtil => ReduxStorageUtil.instance;
